export const ENV = process.env.REACT_APP_ENV
export const VERSION = process.env.REACT_APP_VERSION
export const FE_URL = process.env.REACT_APP_URL_FE || ''

export const MOCKEND_ALL_DISABLED = process.env.REACT_APP_MOCKEND_ALL_DISABLED === 'true'
export const MOCKEND_ALL_ENABLED = process.env.REACT_APP_MOCKEND_ALL_ENABLED === 'false'
export const MOCKEND_TIMING = 800

export const DEFAULT_PIS = process.env.REACT_APP_DEFAULT_PIS === 'true'

export const CONSOLE_LOG_ENABLED = true

export const API_NAME = process.env.REACT_APP_API_NAME || ''
export const ENDPOINT = process.env.REACT_APP_ENDPOINT
export const REGION = process.env.REACT_APP_REGION

export const ID_POLIZZA_PRINCIPALE = 'RC_01'
export const ID_TUTELA_LEGALE = "TL_01"
export const ID_TUTELA_LEGALE_CIVILE_PENALE = "TP_01"
export const ID_PERIZIE_STIME = 'PS_01'

export const MAX_WIDTH = "3000px";